import clsx from 'clsx';
import { LoaderCircle } from 'lucide-react';
import { type ButtonHTMLAttributes, forwardRef } from 'react';

type Variante = 'principal' | 'secundario' | 'discreto' | 'perigo';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variante?: Variante;
  tamanho?: 'normal' | 'compacto';
  /** Bloqueia o botão e mostra o indicador de progresso (evita envio duplo). */
  carregando?: boolean;
}

const estilos: Record<Variante, string> = {
  principal: 'bg-acao text-white hover:bg-acao-escura disabled:bg-acao/50',
  secundario: 'border border-linha bg-superficie text-tinta hover:bg-fundo disabled:text-tinta-2/60',
  discreto: 'text-acao hover:bg-acao-clara disabled:text-tinta-2/60',
  perigo: 'border border-erro/40 bg-superficie text-erro hover:bg-erro-fundo disabled:opacity-50',
};

export const Botao = forwardRef<HTMLButtonElement, Props>(function Botao(
  { variante = 'secundario', tamanho = 'normal', carregando = false, disabled, className, children, type = 'button', ...resto },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled || carregando}
      aria-busy={carregando || undefined}
      className={clsx(
        'inline-flex cursor-pointer items-center justify-center gap-2 rounded-campo font-medium whitespace-nowrap transition-colors duration-150 disabled:cursor-not-allowed',
        tamanho === 'normal' ? 'h-10 px-4' : 'h-8 px-3 text-[13px]',
        estilos[variante],
        className,
      )}
      {...resto}
    >
      {carregando && <LoaderCircle aria-hidden className="size-4 animate-spin" />}
      {children}
    </button>
  );
});
